"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_select_1 = __importDefault(require("react-select"));

var creatable_1 = __importDefault(require("react-select/creatable"));

var Layout_1 = __importDefault(require("../Layout"));

var ChatIcon_1 = __importDefault(require("../ChatIcon"));

var classnames_1 = require("./classnames");

var Button_1 = __importDefault(require("../Button"));

var AutoComplete = function AutoComplete(props) {
  var isChatIconVisible = props.isChatIconVisible,
      icon = props.icon,
      fontFamily = props.fontFamily,
      color = props.color,
      titleMessage = props.titleMessage,
      shouldShowActions = props.shouldShowActions,
      isCreatable = props.isCreatable,
      isMulti = props.isMulti,
      options = props.options,
      handleChange = props.handleChange,
      primaryColor = props.primaryColor,
      handleSubmit = props.handleSubmit,
      font = props.font,
      buttonLabel = props.buttonLabel;
  return React.createElement(Layout_1.default, {
    isUser: false
  }, isChatIconVisible && React.createElement(ChatIcon_1.default, {
    isUser: false,
    icon: icon
  }), React.createElement("div", {
    className: classnames_1.container
  }, React.createElement("div", {
    className: classnames_1.title(fontFamily, color)
  }, titleMessage), shouldShowActions && React.createElement(React.Fragment, null, isCreatable ? React.createElement(creatable_1.default, {
    isMulti: isMulti,
    options: options,
    onChange: handleChange
  }) : React.createElement(react_select_1.default, {
    isMulti: isMulti,
    options: options,
    onChange: handleChange
  }), React.createElement(Button_1.default, {
    font: font,
    handleClick: handleSubmit,
    background: primaryColor,
    label: buttonLabel
  }))));
};

exports.default = AutoComplete;